import { render, staticRenderFns } from "./IBeaconListView.vue?vue&type=template&id=0413d3ea&scoped=true"
import script from "./IBeaconListView.vue?vue&type=script&lang=js"
export * from "./IBeaconListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0413d3ea",
  null
  
)

export default component.exports